import { Component, OnInit } from '@angular/core';
import { InfoService } from "../../api";

@Component({
    selector: 'app-nav-header',
    templateUrl: 'nav-header.component.html',
    standalone: false
})

export class NavHeaderComponent implements OnInit {
 version: string | null = null;

 constructor(private infoService: InfoService) { }

 ngOnInit() {
   this.infoService.getVersionInfo().subscribe(response => {
     this.version = response.Version;
   });
 }
}
